import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpService } from './http.service';
import { EnvironmentService } from './environment.service';
import { StorageService } from './storage.service';
import { Router } from '@angular/router';
import { observeOn } from 'rxjs/operator/observeOn';

@Injectable()
export class UserService {

  private user$: Observable<boolean>;
  private profileEndpoint: string;

  constructor(
    private httpService: HttpService,
    private envService: EnvironmentService,
    private storageService: StorageService,
    private router: Router
  ) {
    this.profileEndpoint = this.envService.get('profileEndpoint');
  }

  public getUserDetails(): Observable<any> {
    return this.httpService.get(this.profileEndpoint).map(
      (user) => {
        this.storageService.setLocalItem('accountUserName' , user.accountUserName);
        this.storageService.setLocalItem('contactNumber' , user.contactNumber);
        this.storageService.setLocalItem('currentStatus' , user.currentStatus);
        this.storageService.setLocalItem('email' , user.email);
        this.storageService.setLocalItem('firstName' , user.firstName);
        this.storageService.setLocalItem('lastName' , user.lastName);
        this.storageService.setLocalItem('userName' , user.userName);
        this.storageService.setLocalItem('uuid' , user.uuid);
        return user;
      },
      (error) => {
        return null;
      }
    );
  }

  public hasUserDetails(): Observable<boolean> {
    const uuid = this.storageService.getLocalItem('uuid');
    if (uuid === null || uuid === 'undefined') {
      this.user$ = this.getUserDetails();
      return this.user$.map(
        (user) => {
          return true;
        },
        (error) => {
          return false;
        }
      );
    }
    return new Observable<boolean>((observer) => {
      observer.next(true);
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/services/user.service.ts